module.exports = __webpack_public_path__ + "media/products/car3-2b305fbf.png";